if (!customElements.get('custom-cart-upsell')) {
  class CustomCartUpsell extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('listener-attached')) {
        this.initCartUpsellListeners();
        this.setAttribute('listener-attached', 'true');
      }
    }

    get hideFrequencySelector() {
      return this.getAttribute('data-hide-frequency-selector') === 'true';
    }

    getSecondSellingPlanId(selectElement) {
      if (!selectElement) return null;

      const availableOptions = Array.from(selectElement.querySelectorAll('option')).filter(
        option => option.value && option.disabled !== true
      );

      // "Second option" = 2nd selling plan option (not the placeholder)
      return availableOptions[1]?.value || availableOptions[0]?.value || null;
    }

     initCartUpsellListeners() {
       const lineItemKey = this.getAttribute('data-line-item-key');
       const quantityAttr = this.getAttribute('data-quantity') || '1';
       const quantity = parseInt(quantityAttr, 10);
       const currentSellingPlanId = this.getAttribute('data-current-selling-plan-id');

       if (!lineItemKey) {
         console.error('CustomCartUpsell: data-line-item-key attribute missing.');
         return;
       }

       // Handle checkbox toggle for subscribe/save
       const checkbox = this.querySelector('.cart-upsell-checkbox');
       const selectElement = this.querySelector('.cart-upsell-selling-plans-select');
       const wrapper = this.querySelector('.cart-upsell-custom-selling-plans-wrapper');

      if (checkbox) {
        checkbox.addEventListener('change', (event) => {
          const isChecked = event.target.checked;

          if (isChecked) {
            if (wrapper) wrapper.style.display = this.hideFrequencySelector ? 'none' : 'block';

            // Only auto-select a plan when the frequency selector is hidden
            if (this.hideFrequencySelector && selectElement && !selectElement.value) {
              const defaultSellingPlanId = this.getSecondSellingPlanId(selectElement);

              if (defaultSellingPlanId) {
                selectElement.value = defaultSellingPlanId;
                selectElement.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
            
            // Track subscription upsell
            const cartItem = this.closest('.cart-item') || this.closest('[data-line-item]');
            if (cartItem && window.trackSubscriptionUpsell) {
              const itemName = cartItem.querySelector('.cart-item__name')?.textContent?.trim() || '';
              const itemSku = cartItem.querySelector('[data-variant-id]')?.getAttribute('data-variant-id') || lineItemKey;
              
              const lineItem = {
                product_title: itemName,
                sku: itemSku,
                variant_id: itemSku
              };
              
              window.trackSubscriptionUpsell(lineItem);
            }
          } else {
            if (wrapper) wrapper.style.display = 'none';
            if (selectElement) selectElement.value = '';
            
            // Only update cart if the item currently has a selling plan
            if (currentSellingPlanId && currentSellingPlanId !== '') {
              this.updateCart({ id: lineItemKey, quantity: quantity, selling_plan: null });
            }
          }
        });
      }

       // Handle selling plan selection change
       if (selectElement) {
        selectElement.addEventListener('change', (event) => {
          const selectedSellingPlanId = event.target.value;

          if (selectedSellingPlanId) {
            if (checkbox) {
              checkbox.checked = true;
            }

            // Only update cart if the selling plan is actually changing
            if (currentSellingPlanId !== selectedSellingPlanId) {
              this.updateCart({
                id: lineItemKey,
                quantity: quantity,
                selling_plan: selectedSellingPlanId
              });
            }
          } else {
            if (checkbox) {
              checkbox.checked = false;
            }

            // Only update cart if the item currently has a selling plan
            if (currentSellingPlanId && currentSellingPlanId !== '') {
              this.updateCart({
                id: lineItemKey,
                quantity: quantity,
                selling_plan: null
              });
            }
          }
        });
      }

    }


    updateCart(updateData) {
      if (!window.liquidAjaxCart || typeof window.liquidAjaxCart.change !== 'function') {
        console.error('CustomCartUpsell: liquidAjaxCart.change API not found.');
        return;
      }

      try {
        window.liquidAjaxCart.change(updateData);
      } catch (err) {
        console.error('CustomCartUpsell: Error updating cart line item:', err);
      }
    }
  }
  customElements.define('custom-cart-upsell', CustomCartUpsell);
}
